import React, { useEffect, useState } from 'react';
import { Section, Title, SelectElement } from './styles';
import { Button, Icon, Input, Select, Upload, message, List } from 'antd';
import { withTranslation } from 'react-i18next';
import { RAISE_NEW_PROBLEM_TICKET_MODAL, RAISE_NEW_REQUEST_TICKET_MODAL } from './TranslationValues';
import { getProductList, createTicket, attachImage } from '../../utils/services/supportAPI';
import { stripHTML } from './Tool';
// import  DeleteOutlined  from '@ant-design/icons';

const NAMESPACE = [
  'RAISE_NEW_PROBLEM_OR_REQUEST_TICKET_MODAL',
  'RAISE_NEW_PROBLEM_TICKET_MODAL',
  'RAISE_NEW_REQUEST_TICKET_MODAL'
]
const NEW_PROBLEM_TICKET = 'RAISE_NEW_PROBLEM_TICKET_MODAL'
const NEW_REQUEST_TICKET = 'RAISE_NEW_REQUEST_TICKET_MODAL'
const RaiseTicketModal = props => {
  const { onSubmit, raiseTicketModalType, t } = props
  const { TextArea } = Input;
  const Option = Select.Option;
  const { Dragger } = Upload;

  const [subject, setSubject] = useState('');
  const [description, setDescription] = useState('');
  const [ProductList, setProductList] = useState([]);
  const [issuseType, setIssuseType] = useState('Document');
  const [priorityType, setPriorityType] = useState('Low');
  const [disableButton, setDisableButton] = useState(true);
  const [loading, setLoading] = useState(false)
  const [fileList, setFileList] = useState([]);

  const priorities = {
    high: 'High',
    med: 'Medium',
    low: 'Low'
  }

  const getProductId = () => {
    const productObject = ProductList && ProductList.find(list => list.name === issuseType);
    return productObject?.id || '';
  };

  // create ticket
  const submitTicket = async (type) => {
    if (disableButton) return;
    setLoading(true);
    setDisableButton(true);

    const data = {
      "subject": subject,
      "description": description,
      "productId": getProductId(issuseType),
      "priority": priorityType,
      "classification": type,
    }
    const raiseTicket = await createTicket(data);
    if (raiseTicket?.statusCode === 2102 && raiseTicket.data) {
      data.ticketId = raiseTicket.data.ticketId;
      data.ticketNumber = raiseTicket.data.ticketNumber;
      let uploadStatus = true;

      const uploadImage = () => {
        fileList.map(async (list) => {
          let form = new FormData();
          form.append('ticketId', raiseTicket.data.ticketId);
          form.append('file', list.originFileObj);

          const result = await attachImage(form);
          if (!result.statusCode === 2111) {
            uploadStatus = false;
            console.log('error', result)
          }
        })
      }
      // Upload Image
      if (fileList.length !== 0) {
        await uploadImage();
      }

      if (uploadStatus) {
        onSubmit(type === "Problem" ? "submitProblem" : "submitRequest", data);
      }
    };

    setLoading(false);
    setDisableButton(false);
  };

  // update attachment
  const handleFileChange = async (info) => {  
    if (fileList > 5 || info.fileList.length > 5) {
      message.error(t(`${NEW_PROBLEM_TICKET}:${RAISE_NEW_PROBLEM_TICKET_MODAL.UPLOAD_LIMIT_ERROR.key}`, RAISE_NEW_PROBLEM_TICKET_MODAL.UPLOAD_LIMIT_ERROR.value));
      return;
    }
 
    const fileExtension = info.file.name.split('.').pop().toLowerCase();
    const imageExtensions = ['jpg', 'jpeg', 'png'];
    if (!imageExtensions.includes(fileExtension)) {
      message.error(t(`${NEW_PROBLEM_TICKET}:${RAISE_NEW_PROBLEM_TICKET_MODAL.UPLOAD_FILE_TYPE_ERROR.key}`, RAISE_NEW_PROBLEM_TICKET_MODAL.UPLOAD_FILE_TYPE_ERROR.value, {value: imageExtensions.join(", ") }));
      return;
    }

    let imageLIst = []
    info.fileList.map((list) => {
      const fileExtension = list.name.split('.').pop().toLowerCase();
      if (imageExtensions.includes(fileExtension)) {
        imageLIst.push(list);
      }
    })
    if (imageLIst.length > 5) {
      imageLIst.length = 5
    }

    setFileList(imageLIst);
  };

  const customRequest = (options) => {
    setTimeout(() => {
      options.onSuccess({});
    }, 1000);
  };


  useEffect(() => {
    if (subject.trim() && description.trim() && issuseType && priorityType) {
      setDisableButton(false)
    } else {
      setDisableButton(true)
    }
  }, [subject, description, issuseType, priorityType]);


  //  Fetch ticket list
  useEffect(() => {
    const fetchList = async () => {
      const result = await getProductList();
      setProductList(result?.data);
    }
    fetchList();
  }, []);


  const handleDelete = (uid) => {   
    // Filter out the item to be deleted
    const updatedItems = fileList.filter(list => list.uid !== uid);
    setFileList(updatedItems);
  };

  return (
    <>
      {raiseTicketModalType === 'REPORT A PROBLEM' ? (
        <Section>
          <div className="createTicketForm">
            <Title className="head">{t(`${NEW_PROBLEM_TICKET}:${RAISE_NEW_PROBLEM_TICKET_MODAL.RAISE_NEW_PROBLEM_TICKET_MODAL_TITLE.key}`, RAISE_NEW_PROBLEM_TICKET_MODAL.RAISE_NEW_PROBLEM_TICKET_MODAL_TITLE.value)}</Title>
            <Title className="head bold">{t(`${NEW_PROBLEM_TICKET}:${RAISE_NEW_PROBLEM_TICKET_MODAL.RAISE_NEW_PROBLEM_TICKET_MODAL_DESCRIPTION.key}`, RAISE_NEW_PROBLEM_TICKET_MODAL.RAISE_NEW_PROBLEM_TICKET_MODAL_DESCRIPTION.value)}</Title>
            <div className="submitTicketForm">
              <div className="formField">
                <div className="fieldLable required-label">{t(`${NEW_PROBLEM_TICKET}:${RAISE_NEW_PROBLEM_TICKET_MODAL.SUBJECT_LABEL.key}`, RAISE_NEW_PROBLEM_TICKET_MODAL.SUBJECT_LABEL.value)}</div>
                <Input maxLength={100} value={subject} onChange={(e) => { setSubject(stripHTML(e.target.value)); }} placeholder={t(`${NEW_PROBLEM_TICKET}:${RAISE_NEW_PROBLEM_TICKET_MODAL.SUBJECT_PLACEHOLDER.key}`, RAISE_NEW_PROBLEM_TICKET_MODAL.SUBJECT_PLACEHOLDER.value)} />
              </div>
              <br />
              <div className="formField">
                <div className="fieldLable required-label">{t(`${NEW_PROBLEM_TICKET}:${RAISE_NEW_PROBLEM_TICKET_MODAL.DESCRIPTION_LABEL.key}`, RAISE_NEW_PROBLEM_TICKET_MODAL.DESCRIPTION_LABEL.value)}</div>
                <TextArea
                  maxLength={1000}
                  value={description}
                  rows={7}
                  onChange={(e) => { setDescription(stripHTML(e.target.value)) }}
                  placeholder={t(`${NEW_PROBLEM_TICKET}:${RAISE_NEW_PROBLEM_TICKET_MODAL.DESCRIPTION_PLACEHOLDER.key}`, RAISE_NEW_PROBLEM_TICKET_MODAL.DESCRIPTION_PLACEHOLDER.value)}
                />
                <div className='desc-length'>{description.length}/1000</div>
              </div>
              <br />
              <div className="dropdowns">
                <div className="formField one">
                  <div className="fieldLable">{t(`${NEW_PROBLEM_TICKET}:${RAISE_NEW_PROBLEM_TICKET_MODAL.SERVICE_DROPDOWN_LABEL.key}`, RAISE_NEW_PROBLEM_TICKET_MODAL.SERVICE_DROPDOWN_LABEL.value)}</div>
                  <SelectElement
                    disabled
                    defaultValue={issuseType}
                    placeholder={`-${t(`${NEW_PROBLEM_TICKET}:${RAISE_NEW_PROBLEM_TICKET_MODAL.NONE_SERVICE_DROPDOWN_OPTION.key}`, RAISE_NEW_PROBLEM_TICKET_MODAL.NONE_SERVICE_DROPDOWN_OPTION.value)}-`}
                    onChange={(e) => { setIssuseType(e) }}
                  >
                    {ProductList && ProductList?.map((list) => {
                      return (<Option value={list.name} key={list.id}>{list.name}</Option>)
                    })}
                  </SelectElement>
                </div>
                <div className="formField two">
                  <div className="fieldLable">{t(`${NEW_PROBLEM_TICKET}:${RAISE_NEW_PROBLEM_TICKET_MODAL.PRIORITY_DROPDOWN_LABEL.key}`, RAISE_NEW_PROBLEM_TICKET_MODAL.PRIORITY_DROPDOWN_LABEL.value)}</div>
                  <SelectElement
                    defaultValue={priorityType}
                    onChange={(e) => { setPriorityType(e) }}
                    placeholder={`-${t(`${NEW_PROBLEM_TICKET}:${RAISE_NEW_PROBLEM_TICKET_MODAL.NONE_SERVICE_DROPDOWN_OPTION.key}`, RAISE_NEW_PROBLEM_TICKET_MODAL.NONE_SERVICE_DROPDOWN_OPTION.value)}-`}
                  >
                    <Option value={priorities.high}>{t(`${NEW_PROBLEM_TICKET}:${RAISE_NEW_PROBLEM_TICKET_MODAL.HIGH_PRIORITY_DROPDOWN_OPTION.key}`, RAISE_NEW_PROBLEM_TICKET_MODAL.HIGH_PRIORITY_DROPDOWN_OPTION.value)}</Option>
                    <Option value={priorities.med}>{t(`${NEW_PROBLEM_TICKET}:${RAISE_NEW_PROBLEM_TICKET_MODAL.MEDIUM_PRIORITY_DROPDOWN_OPTION.key}`, RAISE_NEW_PROBLEM_TICKET_MODAL.MEDIUM_PRIORITY_DROPDOWN_OPTION.value)}</Option>
                    <Option value={priorities.low}>{t(`${NEW_PROBLEM_TICKET}:${RAISE_NEW_PROBLEM_TICKET_MODAL.LOW_PRIORITY_DROPDOWN_OPTION.key}`, RAISE_NEW_PROBLEM_TICKET_MODAL.LOW_PRIORITY_DROPDOWN_OPTION.value)}</Option>
                  </SelectElement>
                </div>
              </div>
              <br />
              <div className="formField">
                <div className="fieldLable">{t(`${NEW_PROBLEM_TICKET}:${RAISE_NEW_PROBLEM_TICKET_MODAL.UPLOAD_ATTACHMENTS_LABEL.key}`, RAISE_NEW_PROBLEM_TICKET_MODAL.UPLOAD_ATTACHMENTS_LABEL.value)}</div>
                <Dragger accept='.jpg,.png,.jpeg' fileList={fileList} multiple={true} className="uploadAttachments" autoUpload={false} onChange={handleFileChange} customRequest={customRequest} showUploadList={false}>
                  <div className="placeholders">
                    <Icon className="uploadIcon" type="upload" />
                    <p className="uploadText">{t(`${NEW_PROBLEM_TICKET}:${RAISE_NEW_PROBLEM_TICKET_MODAL.DRAG_FILE_FOR_UPLOAD_PLACEHOLDER.key}`, RAISE_NEW_PROBLEM_TICKET_MODAL.DRAG_FILE_FOR_UPLOAD_PLACEHOLDER.value)}</p>
                    <p className="ant-upload-hint">{t(`${NEW_PROBLEM_TICKET}:${RAISE_NEW_PROBLEM_TICKET_MODAL.DRAG_FILE_FOR_UPLOAD_NOTE_PLACEHOLDER.key}`, RAISE_NEW_PROBLEM_TICKET_MODAL.DRAG_FILE_FOR_UPLOAD_NOTE_PLACEHOLDER.value)}
                    </p>
                  </div>
                </Dragger>
                <List
                  dataSource={fileList}
                  renderItem={(item, index) => (
                    <List.Item
                      extra={
                        <Button
                          type="link"
                          icon={"delete"}
                          onClick={() => handleDelete(item.uid)}
                        >
                        </Button>
                      }
                    >
                      {item.name}
                    </List.Item>
                  )}
                />
              </div>
            </div>
          </div>
          <div className="raiseTicketActions">
            <Button
              disabled={disableButton}
              loading={loading}
              className="submitBtn"
              id="submitProblem"
              key="ok"
              type="primary"
              onClick={(e) => {
                submitTicket("Problem");
              }}
            >
              {t(`${NEW_PROBLEM_TICKET}:${RAISE_NEW_PROBLEM_TICKET_MODAL.SUBMIT_NEW_PROBLEM_TICKET_BUTTON.key}`, RAISE_NEW_PROBLEM_TICKET_MODAL.SUBMIT_NEW_PROBLEM_TICKET_BUTTON.value)}
            </Button>
          </div>
        </Section>
      ) : (
        <Section>
          <div className="createTicketForm">
            <Title className="head">{t(`${NEW_REQUEST_TICKET}:${RAISE_NEW_REQUEST_TICKET_MODAL.RAISE_NEW_REQUEST_TICKET_MODAL_TITLE.key}`, RAISE_NEW_REQUEST_TICKET_MODAL.RAISE_NEW_REQUEST_TICKET_MODAL_TITLE.value)}</Title>
            <Title className="head bold">{t(`${NEW_REQUEST_TICKET}:${RAISE_NEW_REQUEST_TICKET_MODAL.RAISE_NEW_REQUEST_TICKET_MODAL_DESCRIPTION.key}`, RAISE_NEW_REQUEST_TICKET_MODAL.RAISE_NEW_REQUEST_TICKET_MODAL_DESCRIPTION.value)}</Title>
            <div className="submitTicketForm">
              <div className="formField">
                <div className="fieldLable required-label">{t(`${NEW_REQUEST_TICKET}:${RAISE_NEW_REQUEST_TICKET_MODAL.SUBJECT_LABEL.key}`, RAISE_NEW_REQUEST_TICKET_MODAL.SUBJECT_LABEL.value)}</div>
                <Input value={subject} maxLength={100} onChange={(e) => { setSubject(stripHTML(e.target.value)); }} placeholder={t(`${NEW_REQUEST_TICKET}:${RAISE_NEW_REQUEST_TICKET_MODAL.SUBJECT_PLACEHOLDER.key}`, RAISE_NEW_REQUEST_TICKET_MODAL.SUBJECT_PLACEHOLDER.value)} />
              </div>
              <br />
              <div className="formField">
                <div className="fieldLable required-label">{t(`${NEW_REQUEST_TICKET}:${RAISE_NEW_REQUEST_TICKET_MODAL.DESCRIPTION_LABEL.key}`, RAISE_NEW_REQUEST_TICKET_MODAL.DESCRIPTION_LABEL.value)}</div>
                <TextArea
                  maxLength={1000}
                  value={description}
                  rows={7}
                  onChange={(e) => { setDescription(stripHTML(e.target.value)) }}
                  placeholder={t(`${NEW_REQUEST_TICKET}:${RAISE_NEW_REQUEST_TICKET_MODAL.DESCRIPTION_PLACEHOLDER.key}`, RAISE_NEW_REQUEST_TICKET_MODAL.DESCRIPTION_PLACEHOLDER.value)}
                />
                <div className='desc-length'>{description.length}/1000</div>
              </div>
              <br />
              <div className="dropdowns">
                <div className="formField one">
                  <div className="fieldLable">{t(`${NEW_REQUEST_TICKET}:${RAISE_NEW_REQUEST_TICKET_MODAL.REQUEST_DROPDOWN_LABEL.key}`, RAISE_NEW_REQUEST_TICKET_MODAL.REQUEST_DROPDOWN_LABEL.value)}</div>
                  <SelectElement
                    disabled
                    defaultValue={issuseType}
                    placeholder={`-${t(`${NEW_PROBLEM_TICKET}:${RAISE_NEW_PROBLEM_TICKET_MODAL.NONE_SERVICE_DROPDOWN_OPTION.key}`, RAISE_NEW_PROBLEM_TICKET_MODAL.NONE_SERVICE_DROPDOWN_OPTION.value)}-`}
                    onChange={(e) => { setIssuseType(e) }}
                  >
                    {ProductList && ProductList?.map((list) => {
                      return (<Option value={list.name} key={list.id}>{list.name}</Option>)
                    })}
                  </SelectElement>
                </div>
                <div className="formField two">
                  <div className="fieldLable">{t(`${NEW_REQUEST_TICKET}:${RAISE_NEW_REQUEST_TICKET_MODAL.PRIORITY_DROPDOWN_LABEL.key}`, RAISE_NEW_REQUEST_TICKET_MODAL.PRIORITY_DROPDOWN_LABEL.value)}</div>
                  <SelectElement
                    onChange={(e) => { setPriorityType(e) }}
                    defaultValue={priorityType}
                  >
                    <Option value={priorities.high}>{t(`${NEW_PROBLEM_TICKET}:${RAISE_NEW_PROBLEM_TICKET_MODAL.HIGH_PRIORITY_DROPDOWN_OPTION.key}`, RAISE_NEW_PROBLEM_TICKET_MODAL.HIGH_PRIORITY_DROPDOWN_OPTION.value)}</Option>
                    <Option value={priorities.med}>{t(`${NEW_PROBLEM_TICKET}:${RAISE_NEW_PROBLEM_TICKET_MODAL.MEDIUM_PRIORITY_DROPDOWN_OPTION.key}`, RAISE_NEW_PROBLEM_TICKET_MODAL.MEDIUM_PRIORITY_DROPDOWN_OPTION.value)}</Option>
                    <Option value={priorities.low}>{t(`${NEW_PROBLEM_TICKET}:${RAISE_NEW_PROBLEM_TICKET_MODAL.LOW_PRIORITY_DROPDOWN_OPTION.key}`, RAISE_NEW_PROBLEM_TICKET_MODAL.LOW_PRIORITY_DROPDOWN_OPTION.value)}</Option>
                  </SelectElement>
                </div>
              </div>
              <br />
              <div className="formField">
                <div className="fieldLable">{t(`${NEW_REQUEST_TICKET}:${RAISE_NEW_REQUEST_TICKET_MODAL.UPLOAD_ATTACHMENTS_LABEL.key}`, RAISE_NEW_REQUEST_TICKET_MODAL.UPLOAD_ATTACHMENTS_LABEL.value)}</div>
                <Dragger accept='.jpg,.png,.jpeg' fileList={fileList} className="uploadAttachments" autoUpload={false} onChange={handleFileChange} customRequest={customRequest} multiple showUploadList={false}>
                  <div className="placeholders">
                    <Icon className="uploadIcon" type="upload" />
                    <p className="uploadText">{t(`${NEW_REQUEST_TICKET}:${RAISE_NEW_REQUEST_TICKET_MODAL.DRAG_FILE_FOR_UPLOAD_PLACEHOLDER.key}`, RAISE_NEW_REQUEST_TICKET_MODAL.DRAG_FILE_FOR_UPLOAD_PLACEHOLDER.value)}</p>
                    <p className="ant-upload-hint">{t(`${NEW_REQUEST_TICKET}:${RAISE_NEW_REQUEST_TICKET_MODAL.DRAG_FILE_FOR_UPLOAD_NOTE_PLACEHOLDER.key}`, RAISE_NEW_REQUEST_TICKET_MODAL.DRAG_FILE_FOR_UPLOAD_NOTE_PLACEHOLDER.value)}
                    </p>
                  </div>
                </Dragger>
                <List
                  locale={{ emptyText: '' }} // Set emptyText to an empty string
                  className="custom-no-data-list" // Add a custom class name
                  dataSource={fileList}                  
                  renderItem={(item) => (
                    <List.Item
                      extra={
                        <Button
                          type="link"
                          // icon={<DeleteOutlined />}
                          onClick={() => handleDelete(item.uid)}
                        >
                          {t(`${NEW_REQUEST_TICKET}:${RAISE_NEW_REQUEST_TICKET_MODAL.DELETE_LABEL.key}`, RAISE_NEW_REQUEST_TICKET_MODAL.DELETE_LABEL.value)}
                        </Button>
                      }
                    >
                      {item.name}
                    </List.Item>
                  )}
                />
              </div>
            </div>
          </div>
          <div className="raiseTicketActions">
            <Button
              disabled={disableButton}
              loading={loading}
              className="submitBtn"
              id="submitRequest"
              key="ok"
              type="primary"
              onClick={() => { submitTicket("Request"); }}
            >
              {t(`${NEW_REQUEST_TICKET}:${RAISE_NEW_REQUEST_TICKET_MODAL.SUBMIT_NEW_REQUEST_TICKET_BUTTON.key}`, RAISE_NEW_REQUEST_TICKET_MODAL.SUBMIT_NEW_REQUEST_TICKET_BUTTON.value)}
            </Button>
          </div>
        </Section>
      )}
    </>
  );
};
export default withTranslation(NAMESPACE)(RaiseTicketModal);
